import { render, staticRenderFns } from "./menu-vsc.vue?vue&type=template&id=98e7da9c&scoped=true"
import script from "./menu-vsc.vue?vue&type=script&lang=js"
export * from "./menu-vsc.vue?vue&type=script&lang=js"
import style0 from "./menu-vsc.vue?vue&type=style&index=0&id=98e7da9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e7da9c",
  null
  
)

export default component.exports